module.exports = __webpack_public_path__ + "static/media/nb1.55c7fe77.jpg";